/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeliveryZoneRequest } from '../../models/delivery-zone-request';
import { DeliveryZoneResponse } from '../../models/delivery-zone-response';

export interface DeliveryZonesPut$Params {
  'Active-Tenant-Identifier': string;
  storeId: string;
  zoneId: string;
      body: DeliveryZoneRequest
}

export function deliveryZonesPut(http: HttpClient, rootUrl: string, params: DeliveryZonesPut$Params, context?: HttpContext): Observable<StrictHttpResponse<DeliveryZoneResponse>> {
  const rb = new RequestBuilder(rootUrl, deliveryZonesPut.PATH, 'put');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('storeId', params.storeId, {});
    rb.path('zoneId', params.zoneId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeliveryZoneResponse>;
    })
  );
}

deliveryZonesPut.PATH = '/stores/{storeId}/delivery-zones/{zoneId}';
